import Skeleton from '@components/skeleton'
import { StyleTableBody, StyleTableBodyText, StyleTableRow } from '../style'

const TableLoader = ({ columns, loaderCount = 10 }: any) => {
  return (
    <StyleTableBody>
      {Array(loaderCount)
        ?.fill(0)
        ?.map((_, rowIndex) => (
          <StyleTableRow key={`TableRow-${rowIndex}`}>
            {columns?.map((_: any, colIndex: number) => (
              <StyleTableBodyText key={`tableData-${rowIndex}-${colIndex}`}>
                <Skeleton width={'100%'} height={20} radius={4} />
              </StyleTableBodyText>
            ))}
          </StyleTableRow>
        ))}
    </StyleTableBody>
  )
}

export default TableLoader
